import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  Grid,
  Icon,
  IconButton,
  LinearProgress,
  Paper,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import DeleteIcon from '@material-ui/icons/Delete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import { TreeItem, TreeView } from '@material-ui/lab';
import { debounce } from 'lodash-es';
import moment from 'moment';
import React from 'react';
import Editor from 'react-simple-code-editor';

import { AudienceSegmentEventTypes, track } from '~/src/dash/analytics/analytics';
import {
  AudienceSegmentIsFirstPartyUnknown,
  AudienceSegmentPartnerOnePlusXDMP,
  AudienceSegmentPartnerSamsungDMP,
  AudienceSegmentPartnerUnknown,
  AudienceSegmentThirdPartyPartner,
  AudienceSegmentThirdPartyPartnerCadent,
  AudienceSegmentThirdPartyPartnerLiveRamp,
  AudienceSegmentThirdPartyPartnerTransUnion,
  AudienceSegmentTypeFirstParty,
  AudienceSegmentTypeFirstPartyAutoUpload,
  AudienceSegmentTypeLiverampDataStore,
  AudienceSegmentTypeLiverampOTTHub,
  AudienceSegmentTypeOnePlusXDMP,
  AudienceSegmentTypeSamsungDMP,
  AudienceSegmentTypeTransunion,
  checkSegmentForecast,
  createAudienceSegment,
  deleteAudienceSegment,
  getAudienceSegments,
  HeaderBidderActiveActive,
  IAudienceDeal,
  IAudienceSegment,
  IHeaderBidder,
  ISegmentForecast,
  queryHeaderBidders,
  scheduleSegmentForecast,
  updateAudienceSegment,
  updateDeals,
  uploadSegmentMediafile,
} from '~/src/dash/api/console-api';
import { EBool } from '~/src/dash/api/types/bool';
import { Col, Cols, Row, Rows } from '~/src/dash/components/layout';
import { MaterialSearchDropdownMulti } from '~/src/dash/components/material-search-dropdown-multi';
import ModelMissingPermission from '~/src/dash/components/model-missing-permission';
import { ModelSecondaryButton } from '~/src/dash/components/model-secondary-button';
import { ModelSnackBarProgressBarContainer } from '~/src/dash/components/model-snackbar-progresbar-container';
import { ModelTopBar } from '~/src/dash/components/model-topbar';
import { ModernTextField } from '~/src/dash/components/modern-text-field';
import { SegmentLogicQueryBuilder } from '~/src/dash/components/segment-logic-query-builder/segment-logic-query-builder';
import { Text } from '~/src/dash/components/text';
import { Panel, Panels, spacing } from '~/src/dash/publicaUI';
import { IStore } from '~/src/dash/reducers/store';
import { getColorTheme } from '~/src/dash/resellers/utils/importResellerConfig';
import {
  extractRouteParams,
  navigate,
  RouteAudienceManagerSettingsList,
} from '~/src/dash/router/routes';
import { IListItem, IMenuList } from '~/src/dash/types/menuList';
import {
  IBaseState,
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { ChipInactive } from '~/src/dash/utils/campaign-status';
import { publicaColors } from '~/src/dash/utils/colors';
import { decorate } from '~/src/dash/utils/decorator';
import { formatHugeNumber } from '~/src/dash/utils/format';
import {
  ILiveRampData,
  ILiveRampNode,
  parseLiveRampData,
  parseLiveRampTree,
  searchLiveRampTree,
  sortLiveRampTree,
} from '~/src/dash/utils/liveramp';
import {
  errorColor,
  growGrid,
  growGridLeft,
  growGridRight,
} from '~/src/dash/utils/material-dashboard-react';
import {
  allowedEmptyIPermissionCheck,
  IPermissionCheck,
  IS_AUTHORIZED,
} from '~/src/dash/utils/permission_service';
import { hasRoleSuperUser } from '~/src/dash/utils/roles';
import { routeName } from '~/src/dash/utils/routes';
import {
  filterDMPTaxonomyDataBySearchText,
  ISegmentsDMPTaxonomy,
  parseDMPTaxonomyData,
} from '~/src/dash/utils/segmentsdmp';
import {
  ITransunionData,
  ITransunionNode,
  parseTransunionData,
  parseTransunionTree,
} from '~/src/dash/utils/transunion';
import UploadManager, { EUploadResponseType, IUploadStatus } from '~/src/dash/utils/upload_manager';
import { ButtonView } from '~/src/dash/views/button-view';
import { H3 } from '~/src/dash/views/component-view';
import { SingleSelect } from '~/src/dash/views/singleselect-view';
import { SnackbarView } from '~/src/dash/views/snackbar-view';
import { highlight, languages } from '~/src/prismjs';

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {
  segment: IAudienceSegment;
  combineSegments: boolean;
}

interface IMetaData {
  LiverampCPM?: number;
  DataProvider?: string;
}

interface IState extends IBaseState, IAudienceSegment {
  parsedLiverampData: ILiveRampData[];
  parsedLiverampTree: ILiveRampNode[];
  transunionData: ITransunionData[];
  transunionTree: ITransunionNode[];
  forecast: ISegmentForecast;
  bidders: IHeaderBidder[];
  loadingBidders: boolean;
  loadingLiverampDataStore: boolean;
  loadingTransunionTaxonomy: boolean;
  currentDMPDataStore: ISegmentsDMPTaxonomy[];
  currentDisplayedSegmentsDMPPartner: AudienceSegmentThirdPartyPartner;
  loadingCurrentDMPDataStore: boolean;
  showSelectedDMPSegments: boolean;
  deals: any;

  showLiveRampTree: boolean;
  showTransunionTree: boolean;
  checkingForecast: boolean;
  schedulingReport: boolean;
  saving: boolean;
  uploading: boolean;
  count: number;

  snackbarMessage: string;
  snackbarError: boolean;

  readAuthorization: IPermissionCheck;
  writeAuthorization: IPermissionCheck;
  bidderFilter: string;

  // states related to table pagination
  page: number;
  rowsPerPage: number;

  // states related to sorting
  orderBy: string;
  orderDirection: 'asc' | 'desc';

  // states related to combine segments
  segmentList: IMenuList;
  liveRampSegments: IAudienceSegment[];
  selectedSegmentIDs: string[];

  // states related to the search bar for Live ramp tree
  searchTreeText: string;
}

interface ISegmentLogicQueryItems {
  label: string;
  value: string;
}

function isExistingSegment(segment: IAudienceSegment) {
  return !!segment.ID;
}

const getNewSegmentAttributesByType = (type: string): { [key: string]: any } | void => {
  if (type === AudienceSegmentTypeFirstParty) {
    return {
      IsFirstParty: EBool.EBool_TRUE,
    };
  } else if (type === AudienceSegmentTypeLiverampDataStore) {
    return {
      IsFirstParty: EBool.EBool_FALSE,
      Partner: AudienceSegmentThirdPartyPartnerLiveRamp,
    };
  } else if (type === AudienceSegmentTypeTransunion) {
    return {
      IsFirstParty: EBool.EBool_FALSE,
      Partner: AudienceSegmentThirdPartyPartnerTransUnion,
    };
  } else if (type === AudienceSegmentTypeSamsungDMP) {
    return {
      IsFirstPart: EBool.EBool_FALSE,
      Partner: AudienceSegmentPartnerSamsungDMP,
    };
  } else if (type === AudienceSegmentTypeOnePlusXDMP) {
    return {
      IsFirstParty: EBool.EBool_FALSE,
      Partner: AudienceSegmentPartnerOnePlusXDMP,
    };
  }
};

const TransunionTaxonomyS3Path =
  'https://admedia.publica-ctv.com/transunion_taxonomy/transunion_taxonomy.csv';
const OnePlusXTaxonomyPathMapByPubID: { [key: string]: string } = {
  773: 'https://admedia.publica-ctv.com/1plusx-dmp_datastore/deduped_taxonomy/TegnaUS_taxonomy.tsv',
};

export const AudienceManagerSegmentFormView = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    styles: (theme: any) => ({
      paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 4,
      },
      section: {
        display: 'block',
        marginBottom: theme.spacing.unit * 4,
      },
      button: {
        margin: theme.spacing.unit,
      },
      growGrid,
      growGridLeft,
      growGridRight,
      errorColor: {
        color: errorColor,
      },
      clampTableCell: {
        whiteSpace: 'nowrap',
        width: '1px',
      },
    }),
    router: true,
  },
  class extends React.Component<IProps, IState> {
    state = Object.assign(this.props.segment, {
      parsedLiverampData: [] as ILiveRampData[],
      parsedLiverampTree: [] as ILiveRampNode[],
      transunionData: [] as ITransunionData[],
      transunionTree: [] as ITransunionNode[],
      forecast: {} as ISegmentForecast,
      bidders: [] as IHeaderBidder[],
      loadingBidders: false,
      loadingLiverampDataStore: false,
      loadingTransunionTaxonomy: false,
      currentDMPDataStore: [] as ISegmentsDMPTaxonomy[],
      currentDisplayedSegmentsDMPPartner: AudienceSegmentPartnerUnknown,
      loadingCurrentDMPDataStore: false,
      showSelectedDMPSegments: false,

      deals: {} as any,

      showLiveRampTree: !this.props.segment.ID,
      showTransunionTree: !this.props.segment.ID,
      checkingForecast: false,
      schedulingReport: false,
      saving: false,
      uploading: false,
      count: 0,
      snackbarMessage: '',
      snackbarError: false,

      readAuthorization: allowedEmptyIPermissionCheck,
      writeAuthorization: allowedEmptyIPermissionCheck,
      bidderFilter: '',

      page: 0,
      rowsPerPage: 25,
      orderBy: 'Name',
      orderDirection: 'asc' as 'asc' | 'desc',

      segmentList: {} as IMenuList,
      liveRampSegments: [] as IAudienceSegment[],
      selectedSegmentIDs: [] as string[],

      searchTreeText: '',
    });

    uploadManager = new UploadManager();
    uploadKeyToIdx = new Map<string, { idx: number }>();

    _saveSegment = debounce((count: number) => {
      let segmentMetadata: IMetaData = {};
      // Add liveramp CPM and data provider metadata to segment on save
      if (this.state.AudienceSegmentType === AudienceSegmentTypeLiverampDataStore) {
        segmentMetadata = this.addSegmentMetadata();
      } else if (this.state.AudienceSegmentType === AudienceSegmentTypeFirstParty) {
        segmentMetadata = {
          DataProvider: 'First Party',
        };
      } else if (this.state.AudienceSegmentType === AudienceSegmentTypeLiverampOTTHub) {
        segmentMetadata = {
          DataProvider: 'OTT Hub',
        };
      }

      const enrichedSegment = Object.assign({}, this.state, segmentMetadata);
      if (count !== this.state.count) {
        return;
      }
      if (!this.state.LogicQuery) {
        this.setState({
          saving: false,
          snackbarMessage: 'At least one segment must be present in the Segment Logic',
          snackbarError: true,
        });
        return;
      }
      (isExistingSegment(this.state)
        ? updateAudienceSegment({
            body: {
              publisher_id: this.props.session.publisher.ID,
              segment_id: this.state.ID,
              segment: enrichedSegment,
            },
          })
        : createAudienceSegment({
            query: Object.assign({
              publisher_id: this.props.session.publisher.ID,
              segment: enrichedSegment,
            }),
          })
      )
        .then((segment: IAudienceSegment) => {
          this.setState(
            Object.assign(this.state, segment, {
              saving: false,
            }),
          );
        })
        .then(() => {
          this.saveDeals(); // Save the deals as well
          this.setState({
            saving: false,
          });
        })
        .catch((err: Error) => {
          this.setState({
            saving: false,
            snackbarMessage: err.toString(),
            snackbarError: true,
          });
        });
    }, 500);

    _saveDeals = debounce((count: number) => {
      if (count !== this.state.count) {
        return;
      }
      updateDeals({
        body: {
          publisher_id: this.props.session.publisher.ID,
          segment_id: this.state.ID,
          deals: this.state.deals,
        },
      }).then(
        (deals: IAudienceDeal[]) => {
          deals.forEach((deal: IAudienceDeal) => {
            this.state.deals[deal.BidderID] = deal;
          });
          this.setState({
            deals: this.state.deals,
            saving: false,
            snackbarMessage: 'Successfully saved audience segment',
            snackbarError: false,
          });
        },
        (err: Error) => {
          this.setState({
            saving: false,
            snackbarMessage: 'Failed to save audience segment' + err.toString(),
            snackbarError: true,
          });
        },
      );
    }, 500);

    renderNewSegmentLogic() {
      const segmentIDs = this.state.ThirdPartySegmentIDs.split(',');
      let items: ISegmentLogicQueryItems[] = [];
      if (this.state.AudienceSegmentType === AudienceSegmentTypeLiverampDataStore) {
        const liverampData = this.state.parsedLiverampData;
        items = liverampData
          .filter((data: ILiveRampData) => {
            return segmentIDs.includes(data.DataStoreSegmentID);
          })
          .map((data: ILiveRampData) => {
            return {
              label: [data.DataStoreSegmentID, data.Description, data.Provider, data.Price].join(
                ' | ',
              ),
              value: data.DataStoreSegmentID,
            };
          });
      }
      if (this.state.AudienceSegmentType === AudienceSegmentTypeTransunion) {
        const transunionData = this.state.transunionData;
        items = transunionData
          .filter((data: ITransunionData) => {
            return segmentIDs.includes(data.ID);
          })
          .map((data: ITransunionData) => {
            return {
              label: [data.ID, data.Description, data.Meta1, data.Meta2, data.Price].join(' | '),
              value: data.ID,
            };
          });
      }
      if (
        this.state.AudienceSegmentType === AudienceSegmentTypeSamsungDMP ||
        this.state.AudienceSegmentType === AudienceSegmentTypeOnePlusXDMP
      ) {
        const allDMPsegments = this.state.currentDMPDataStore;
        items = allDMPsegments
          .filter((data: ISegmentsDMPTaxonomy) => {
            return segmentIDs.includes(data.DMPSegmentID);
          })
          .map((data: ISegmentsDMPTaxonomy) => {
            return {
              label:
                data.DMPSegmentID +
                ' > ' +
                data.DataProviderName +
                ' > ' +
                data.DataProviderID +
                ' > ' +
                data.HeirarchicalSegmentName,
              value: data.DMPSegmentID,
            };
          });
      }

      if (items.length === 0) {
        return <></>;
      }

      return (
        <>
          <Divider
            style={{
              marginBottom: '24px',
              marginTop: '14px',
              height: '1px',
            }}
          />
          <div style={{ margin: '24px 0' }}>
            <H3>Segment Logic</H3>
            <Text style={{ marginBottom: 0 }}>
              Combine selected audience segments using logic to reach users with granularity. By
              default all logic options are inactive until selected.
            </Text>
            <Text style={{ fontWeight: 500 }}>
              Logic options: "NOT" exclude a specific segment or group. "AND" all audience segment
              constraints must be true. "OR" any of the audience segment constraints must be true.
            </Text>
            <SegmentLogicQueryBuilder
              items={items}
              queryJson={this.state.LogicQueryJson}
              oldLogic={this.state.Logic}
              onUpdate={this.handleLogicQueryUpdate}
            />
          </div>
        </>
      );
    }

    componentDidMount() {
      const { session, user } = this.props;

      const readAuthorization = IS_AUTHORIZED(['read_audience_manager'], user.user);
      const writeAuthorization = IS_AUTHORIZED(['write_audience_manager'], user.user);
      this.setState({
        readAuthorization,
        writeAuthorization,
      });

      if (!readAuthorization.isAuthorized) {
        return;
      }

      this.uploadManager.events.addListener(
        'uploadManager_uploadStatusChange',
        (item: IUploadStatus) => {
          if (item.status === EUploadResponseType.ABORTED && this.uploadKeyToIdx.has(item.key)) {
            const itemLocation = this.uploadKeyToIdx.get(item.key);
            if (itemLocation === undefined) {
              return;
            }
          }
        },
      );

      this.setState({
        loadingBidders: true,
        loadingLiverampDataStore: true,
        loadingSamsungDMPDataStore: true,
      });
      if (session.publisher.LiverampDataStore !== '') {
        fetch(session.publisher.LiverampDataStore, {
          method: 'GET',
        })
          .then((json: any) => {
            json.text().then((liverampDataStore: any) => {
              const liverampData = parseLiveRampData(liverampDataStore);
              const liverampTree = parseLiveRampTree(liverampData);
              this.setState({
                loadingLiverampDataStore: false,
                parsedLiverampData: liverampData,
                parsedLiverampTree: liverampTree,
              });
            });
          })
          .catch(() => {
            this.setState({
              loadingLiverampDataStore: false,
            });
          });
      }
      if (session.publisher.TransunionEnabled === EBool.EBool_TRUE) {
        fetch(TransunionTaxonomyS3Path, {
          method: 'GET',
        })
          .then((json: any) => {
            json.text().then((transunionTaxonomy: any) => {
              const transunionData = parseTransunionData(transunionTaxonomy);
              const transunionTree = parseTransunionTree(transunionData);
              this.setState({
                loadingTransunionTaxonomy: false,
                transunionData,
                transunionTree,
              });
            });
          })
          .catch(() => {
            this.setState({
              loadingTransunionTaxonomy: false,
            });
          });
      }

      const isExistingSamsungDMPSegment =
        this.state.AudienceSegmentType === AudienceSegmentTypeSamsungDMP &&
        session.publisher.SamsungDMPEnabled === EBool.EBool_TRUE;
      const isExistingOnePlusXDMPSegment =
        this.state.AudienceSegmentType === AudienceSegmentTypeOnePlusXDMP &&
        session.publisher.OnePlusXDMPEnabled === EBool.EBool_TRUE;
      let dmpURL = '';
      let dmpPartner = AudienceSegmentPartnerUnknown;

      if (isExistingSamsungDMPSegment) {
        dmpURL = session.publisher.SamsungDMPDataStore;
        dmpPartner = AudienceSegmentPartnerSamsungDMP;
      } else if (
        isExistingOnePlusXDMPSegment &&
        OnePlusXTaxonomyPathMapByPubID[session.publisher.ID]
      ) {
        dmpURL = OnePlusXTaxonomyPathMapByPubID[session.publisher.ID];
        dmpPartner = AudienceSegmentPartnerOnePlusXDMP;
      }

      if (dmpURL !== '' && dmpPartner !== AudienceSegmentPartnerUnknown) {
        this.fetchDMPTaxonomyDataByPartner(dmpURL, dmpPartner);
      }

      queryHeaderBidders({
        query: {
          publisher_id: session.publisher.ID,
          site_ids: '',
          include_deleted: false,
          include_deals: true,
        },
      }).then((bidders: IHeaderBidder[]) => {
        if (!hasRoleSuperUser(user.user)) {
          bidders = bidders.filter((row: IHeaderBidder) => {
            return !row.SuperOnly;
          });
        }
        bidders = bidders.filter((row: IHeaderBidder) => {
          return row.Active === HeaderBidderActiveActive;
        });
        const deals: any = {};
        bidders.forEach((hb: IHeaderBidder) => {
          hb.AudienceDeals.forEach((deal: IAudienceDeal) => {
            if (deal.SegmentID === this.state.ID) {
              deals[deal.BidderID] = deal;
            }
          });
          if (!deals[hb.ID]) {
            deals[hb.ID] = {} as IAudienceDeal;
          }
        });
        this.setState({
          bidders,
          loadingBidders: false,
          deals,
        });
      });
    }

    componentWillUnmount() {
      this.uploadManager.cleanup();
    }

    trackEvent = (
      eventTitle: AudienceSegmentEventTypes,
      thirdPartySegmentID: string | undefined = undefined,
      thirdPartySegmentName: string[] | undefined = undefined,
      enabled: boolean | undefined = undefined,
    ): void => {
      const is_super_user = hasRoleSuperUser(this.props.user.user);
      track(
        eventTitle,
        {
          is_super_user,
          segmentName: this.state.Name,
          thirdPartySegmentID,
          thirdPartySegmentName,
          enabled,
        },
        this.props.user.user,
      );
    };

    addSegmentMetadata = () => {
      const liverampData = this.state.parsedLiverampData;
      const metaData: IMetaData = {
        LiverampCPM: 0,
        DataProvider: '',
      };

      liverampData.forEach((data: ILiveRampData) => {
        if (this.getCheckboxStatus(data.DataStoreSegmentID)) {
          // Find the selected segment with the highest CPM and use that CPM and DataProvider as metadata
          if (data.Price === '' && 1.75 > (metaData.LiverampCPM || 0)) {
            // This is a Liveramp first-party segment so we use a fixed CPM of 1.75
            metaData.LiverampCPM = 1.75;
            metaData.DataProvider = 'Liveramp First Party';
          } else {
            // This is a Liveramp third-party segment so we use the provided CPM
            const priceValue = parseFloat(data.Price);
            if (!!priceValue && priceValue > (metaData.LiverampCPM || 0)) {
              metaData.LiverampCPM = priceValue;
              metaData.DataProvider = data.Provider;
            }
          }
        }
      });

      return metaData;
    };

    saveSegment = () => {
      const count = this.state.count + 1;
      this.setState(
        {
          saving: true,
          count,
        },
        () => {
          this._saveSegment(count);
        },
      );
    };

    saveDeals = () => {
      const count = this.state.count + 1;
      this.setState(
        {
          saving: true,
          count,
        },
        () => {
          this._saveDeals(count);
        },
      );
    };

    checkForecast = () => {
      if (this.state.ID === '') {
        return;
      }

      this.trackEvent('Audience Manager - Forecasting Tool');

      this.setState({
        forecast: {} as ISegmentForecast,
        checkingForecast: true,
      });

      // HLL
      checkSegmentForecast({
        query: {
          publisher_id: this.props.session.publisher.ID,
          segment_id: this.state.ID,
          hll_start: moment(Date.now()).subtract(32, 'days').format('YYYY-MM-DD'),
          hll_end: moment(Date.now()).subtract(2, 'days').format('YYYY-MM-DD'),
        },
      })
        .then((forecast: ISegmentForecast) => {
          this.setState(
            {
              forecast,
              checkingForecast: false,
            },
            () => {
              if (!forecast.Success) {
                this.setState({
                  snackbarMessage: forecast.Message,
                  snackbarError: true,
                });
              }
            },
          );
        })
        .catch(() => {
          this.setState({
            snackbarMessage: 'Error while retrieving forecast for HLL',
            snackbarError: true,
            checkingForecast: false,
          });
        });
    };

    scheduleReport = () => {
      if (this.state.ID === '') {
        return;
      }

      this.trackEvent('Audience Manager - Forecasting Email');

      this.setState({
        schedulingReport: true,
      });
      scheduleSegmentForecast({
        query: {
          publisher_id: this.props.session.publisher.ID,
          segment_id: this.state.ID,
          hll_start: moment(Date.now()).subtract(32, 'days').format('YYYY-MM-DD'),
          hll_end: moment(Date.now()).subtract(2, 'days').format('YYYY-MM-DD'),
        },
      })
        .then((json: any) => {
          this.setState({
            schedulingReport: false,
            snackbarMessage: json.message,
            snackbarError: !json.success,
          });
        })
        .catch(() => {
          this.setState({
            snackbarMessage: 'Error while schedule forecast',
            snackbarError: true,
            schedulingReport: false,
          });
        });

      // set schedulingReport as false, if we did not receive response in 10 seconds(which means system is querying data)
      setTimeout(() => {
        if (this.state.schedulingReport) {
          this.setState({
            schedulingReport: false,
            snackbarMessage:
              'Successfully sent segment forecast data request to server. An email will be sent to your email when the data is ready.',
          });
        }
      }, 10000);
    };

    handleChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      if (target.name === 'bidderFilter') {
        this.setState({
          [target.name]: target.value,
          page: 0,
        });
      } else {
        this.setState({
          [target.name]: target.value,
        });
      }
    };

    handleChangeSelect = (name: string, value: string) => {
      const { session } = this.props;
      if (value) {
        let dmpURL = '';
        let dmpPartner = AudienceSegmentPartnerUnknown;
        if (value === AudienceSegmentTypeSamsungDMP) {
          dmpURL = session.publisher.SamsungDMPDataStore;
          dmpPartner = AudienceSegmentPartnerSamsungDMP;
        } else if (
          value === AudienceSegmentTypeOnePlusXDMP &&
          OnePlusXTaxonomyPathMapByPubID[session.publisher.ID]
        ) {
          dmpURL = OnePlusXTaxonomyPathMapByPubID[session.publisher.ID];
          dmpPartner = AudienceSegmentPartnerOnePlusXDMP;
        }
        if (dmpURL !== '' && dmpPartner !== AudienceSegmentPartnerUnknown) {
          this.fetchDMPTaxonomyDataByPartner(dmpURL, dmpPartner);
        }

        this.setState(
          Object.assign(
            {
              [name]: value,
              ThirdPartySegmentIDs: '',
            },
            name === 'AudienceSegmentType' && getNewSegmentAttributesByType(value),
          ),
        );
      }
    };

    handleChangeSegmentType = (name: string, value: string) => {
      const { session } = this.props;
      const filteredSegments = {} as IMenuList;
      const liveRampSegments: IAudienceSegment[] = [];

      getAudienceSegments({
        query: {
          publisher_id: session.publisher.ID,
        },
      }).then((segments: IAudienceSegment[]) => {
        segments.map((segment: IAudienceSegment) => {
          if (
            segment.Partner === AudienceSegmentThirdPartyPartnerLiveRamp &&
            segment.ThirdPartySegmentIDs !== ''
          ) {
            liveRampSegments.push(segment);
            filteredSegments[segment.ID] = {
              ID: segment.ID,
              title: segment.Name,
              selected: false,
            } as IListItem;
          }
        });
        this.setState({
          [name]: value,
          uploading: true,
          showLiveRampTree: false,
          liveRampSegments,
          segmentList: filteredSegments,
        });
      });
    };

    handleItemAcceptClick = (list: IMenuList) => {
      const selectedSegmentIDs = Object.values(list)
        .filter(({ selected }) => selected)
        .map(({ ID }) => ID);

      let selectedThirdPartySegmentIDs = new Set<string>();
      if (this.state.ThirdPartySegmentIDs !== '') {
        selectedThirdPartySegmentIDs = new Set<string>(this.state.ThirdPartySegmentIDs.split(','));
      }
      this.state.liveRampSegments.forEach((segment: IAudienceSegment) => {
        if (selectedSegmentIDs.includes(segment.ID)) {
          const convertThirdPartySegmentIDsToArray = segment.ThirdPartySegmentIDs.split(',');
          convertThirdPartySegmentIDsToArray.map((thirdPartySegmentId) => {
            selectedThirdPartySegmentIDs.add(thirdPartySegmentId);
          });
        }
      });

      this.setState(
        Object.assign(
          {
            ThirdPartySegmentIDs: Array.from(selectedThirdPartySegmentIDs).join(','),
            uploading: selectedSegmentIDs.length >= 1 ? false : true,
            selectedSegmentIDs,
          },
          getNewSegmentAttributesByType(this.state.AudienceSegmentType),
        ),
      );

      if (selectedSegmentIDs.length === 0) {
        this.setState({
          ThirdPartySegmentIDs: '',
          uploading: true,
        });
      }
    };

    handleDeleteSegment = () => {
      deleteAudienceSegment({
        query: {
          publisher_id: this.props.session.publisher.ID,
          segment_id: this.state.ID,
        },
      })
        .then(() => {
          this.setState(
            {
              snackbarMessage: 'Successfully deleted segment',
              snackbarError: false,
              updating: false,
            },
            this.gotoAudienceManagerSettings,
          );
        })
        .catch((err) => {
          console.error(err);
          this.setState({
            snackbarMessage: 'Error while deleting segment',
            snackbarError: true,
            updating: false,
          });
        });
    };

    fetchDMPTaxonomyDataByPartner(
      dataStoreURL: string,
      audienceSegmentPartner: AudienceSegmentThirdPartyPartner,
    ) {
      fetch(dataStoreURL, {
        method: 'GET',
      })
        .then((json: any) => {
          if (json.status !== 200) {
            this.setState({
              currentDMPDataStore: [],
              loadingCurrentDMPDataStore: false,
              currentDisplayedSegmentsDMPPartner: AudienceSegmentPartnerUnknown,
            });
            return;
          }
          json.text().then((dmpDataStore: any) => {
            this.setState({
              currentDMPDataStore: parseDMPTaxonomyData(dmpDataStore),
              loadingCurrentDMPDataStore: false,
              currentDisplayedSegmentsDMPPartner: audienceSegmentPartner,
            });
          });
        })
        .catch(() => {
          this.setState({
            currentDMPDataStore: [],
            loadingCurrentDMPDataStore: false,
            currentDisplayedSegmentsDMPPartner: AudienceSegmentPartnerUnknown,
          });
        });
    }

    handleFileSelect = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      if (target.files && target.files.length > 0) {
        const file = target.files[0];
        target.value = '';
        this.setState({
          uploading: true,
        });

        // add the file to the upload manager
        const uploadKey = this.uploadManager.addUpload(file.name);

        uploadSegmentMediafile({
          publisher_id: this.props.session.publisher.ID,
          name: file.name.split('.')[0],
          file,
          managerFunc: (xhr: XMLHttpRequest) => {
            this.uploadManager.addListenersToUpload(uploadKey, xhr);
          },
        })
          .then((json: any) => {
            if (json.response.success) {
              this.setState({
                snackbarMessage: 'Upload successful',
                snackbarError: false,
                uploading: false,
                URL: json.response.url,
              });
              this.uploadManager.signalSuccess(uploadKey);
            } else {
              this.setState({
                snackbarMessage: 'Upload failed',
                snackbarError: true,
                uploading: false,
              });
              this.uploadManager.signalFailure(uploadKey);
            }
          })
          .catch(() => {
            this.setState({
              snackbarMessage: 'Upload failed',
              snackbarError: true,
              uploading: false,
            });
            this.uploadManager.signalFailure(uploadKey);
          });
      }
    };

    handleLogicQueryUpdate = (query: string, queryJson: string) => {
      this.setState({
        LogicQuery: query,
        LogicQueryJson: queryJson,
      });
    };

    handleSetSearchTreeText = (e: any) => {
      this.setState({
        searchTreeText: e.target.value,
      });
    };

    snackbarClose = () => {
      this.setState({
        snackbarMessage: '',
        snackbarError: false,
      });
    };

    gotoAudienceManagerSettings = () => {
      navigate(
        RouteAudienceManagerSettingsList,
        extractRouteParams({
          session: this.props.session,
          user: this.props.user,
        }),
      );
    };

    renderSqlTextBox(text: string) {
      return (
        <Editor
          placeholder={''}
          value={text}
          highlight={(code) => highlight(code, languages.sql, 'sql')}
          padding={0}
          maxLength={1000}
          onValueChange={() => null}
          readOnly={true}
        />
      );
    }

    renderForecastDebugQuery(forecast: ISegmentForecast) {
      return (
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='debug-queries-content'
            id='debug-queries-header'
          >
            <Typography>* Debug Queries</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: '50px',
                backgroundColor: '#f7faff',
                paddingLeft: '10px',
                paddingRight: '10px',
              }}
            >
              <p style={{ fontWeight: 500 }}>* Queries</p>
              <div style={{ marginBottom: 10 }}>
                <p style={{ fontWeight: 500 }}>Audience:</p>
                {this.renderSqlTextBox(forecast.SegmentQuery)}
              </div>
              <div style={{ marginBottom: 10 }}>
                <p style={{ fontWeight: 500 }}>Unique Users for Publisher:</p>
                {this.renderSqlTextBox(forecast.UniqueQuery)}
              </div>
              {forecast.UniqueUsersForSegmentHLLQuery !== '' && (
                <div style={{ marginBottom: 10 }}>
                  <p style={{ fontWeight: 500 }}>Unique Users for Segment (HLL):</p>
                  {this.renderSqlTextBox(forecast.UniqueUsersForSegmentHLLQuery)}
                </div>
              )}
            </div>
          </AccordionDetails>
        </Accordion>
      );
    }

    renderForecastingTool() {
      const { classes, user } = this.props;

      const { checkingForecast, forecast, schedulingReport } = this.state;

      const isSuperUser = hasRoleSuperUser(user.user);

      const uniqueUserPercentage = forecast.PublisherUniqueDeviceIDs
        ? (
            (forecast.SegmentUniqueDeviceIDs * 100) /
            forecast.PublisherUniqueDeviceIDs
          ).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%'
        : 'N/A';

      return (
        <div className={classes.section}>
          <Divider
            style={{
              marginBottom: '24px',
              marginTop: '14px',
              height: '1px',
            }}
          />
          <div>
            <div style={{ display: 'flex' }}>
              <img src='/assets/shared/svg/forecast.svg' style={{ width: '20px' }} />
              &nbsp;&nbsp;
              <Typography style={{ fontWeight: 500, fontSize: '1.2rem' }}>
                Forecasting Tool
              </Typography>
            </div>

            <Grid container direction='row' justify='flex-start' alignItems='center'>
              <Grid item>
                <p
                  style={{
                    backgroundColor: '#edeff0',
                    padding: '2px',
                    borderRadius: '3px',
                    marginRight: '4px',
                  }}
                >
                  Last 30D
                </p>
              </Grid>
              <Grid item>
                <p style={{ marginBottom: 20, paddingTop: '4px' }}>
                  Using historical data over the past 30 days to forecast the size of your audience
                  segment and the associated revenue opportunity
                </p>
              </Grid>
            </Grid>

            {
              // Loading forecast
              checkingForecast && <LinearProgress color='primary' />
            }

            {
              // Error, render err msg + debug query
              !forecast.Success && forecast.Message !== '' && forecast.Message !== undefined && (
                <>
                  <span>{forecast.Message}</span>
                </>
              )
            }

            {
              // Success, render success + debug query
              forecast.Success && (
                <>
                  <Grid container direction='column' justify='flex-start' alignItems='flex-start'>
                    <Grid
                      item
                      container
                      direction='row'
                      justify='flex-start'
                      alignItems='flex-start'
                      spacing={4}
                    >
                      <Grid item xs={5} style={{ fontWeight: 600, fontSize: 14 }}>
                        Audience
                      </Grid>
                      <Grid item xs={3}>
                        Metric
                      </Grid>
                      <Grid item xs={3}>
                        Percentage of total users
                      </Grid>
                    </Grid>
                    <Divider
                      style={{
                        width: '90%',
                        marginBottom: '8px',
                        marginTop: '2px',
                        height: '1px',
                      }}
                    />
                    <Grid
                      item
                      container
                      direction='row'
                      justify='flex-start'
                      alignItems='flex-start'
                      spacing={4}
                    >
                      <Grid item xs={5} style={{ fontWeight: 500 }}>
                        Unique Users
                        <p
                          style={{
                            marginTop: '-2px',
                            fontSize: '10px',
                            fontWeight: 400,
                            fontStyle: 'italic',
                          }}
                        >
                          # of uniques users within segment
                        </p>
                      </Grid>
                      <Grid item xs={3} style={{ fontWeight: 500 }}>
                        {formatHugeNumber(forecast.SegmentUniqueDeviceIDs)}
                      </Grid>
                      <Grid item xs={3} style={{ fontWeight: 500 }}>
                        {uniqueUserPercentage}{' '}
                        <p style={{ marginTop: '-2px', fontSize: '10px', fontWeight: 400 }}>
                          ({formatHugeNumber(forecast.SegmentUniqueDeviceIDs)}/
                          {formatHugeNumber(forecast.PublisherUniqueDeviceIDs)})
                        </p>
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      container
                      direction='row'
                      justify='flex-start'
                      alignItems='flex-start'
                      style={{ paddingTop: '19px' }}
                      spacing={4}
                    >
                      <Grid item xs={5} style={{ fontWeight: 600, fontSize: 14 }}>
                        Delivery
                      </Grid>
                      <Grid item xs={3}>
                        Metric
                      </Grid>
                    </Grid>
                    <Divider
                      style={{
                        width: '75%',
                        marginBottom: '8px',
                        marginTop: '2px',
                        height: '1px',
                      }}
                    />
                    <Grid
                      item
                      container
                      direction='row'
                      justify='flex-start'
                      alignItems='flex-start'
                      spacing={4}
                    >
                      <Grid item xs={5} style={{ fontWeight: 500 }}>
                        Endpoint Requests
                        <p
                          style={{
                            marginTop: '-2px',
                            fontSize: '10px',
                            fontWeight: 400,
                            fontStyle: 'italic',
                          }}
                        >
                          # of endpoint requests from users within this segment
                        </p>
                      </Grid>
                      <Grid item xs={3} style={{ fontWeight: 500 }}>
                        {formatHugeNumber(forecast.EndpointRequests)}
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      container
                      direction='row'
                      justify='flex-start'
                      alignItems='flex-start'
                      spacing={4}
                    >
                      <Grid item xs={5} style={{ fontWeight: 500 }}>
                        Impressions
                        <p
                          style={{
                            marginTop: '-2px',
                            fontSize: '10px',
                            fontWeight: 400,
                            fontStyle: 'italic',
                          }}
                        >
                          # of impressions delivered to users within this segment
                        </p>
                      </Grid>
                      <Grid item xs={3} style={{ fontWeight: 500 }}>
                        {formatHugeNumber(forecast.Impressions)}
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      container
                      direction='row'
                      justify='flex-start'
                      alignItems='flex-start'
                      spacing={4}
                    >
                      <Grid item xs={5} style={{ fontWeight: 500 }}>
                        CPM
                        <p
                          style={{
                            marginTop: '-2px',
                            fontSize: '10px',
                            fontWeight: 400,
                            fontStyle: 'italic',
                          }}
                        >
                          Avg CPM paid for users within this segment
                        </p>
                      </Grid>
                      <Grid item xs={3} style={{ fontWeight: 500 }}>
                        $ {formatHugeNumber(forecast.AvgImpECPM)}
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      container
                      direction='row'
                      justify='flex-start'
                      alignItems='flex-start'
                      spacing={4}
                    >
                      <Grid item xs={5} style={{ fontWeight: 500 }}>
                        Revenue
                        <p
                          style={{
                            marginTop: '-2px',
                            fontSize: '10px',
                            fontWeight: 400,
                            fontStyle: 'italic',
                          }}
                        >
                          Total revenue generated by users within this segment
                        </p>
                      </Grid>
                      <Grid item xs={3} style={{ fontWeight: 500 }}>
                        $ {formatHugeNumber(forecast.Revenue)}
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              )
            }
          </div>
          <Button
            onClick={this.checkForecast}
            style={{
              color: getColorTheme('secondaryButtonText'),
              marginBottom: '20px',
              marginTop: '20px',
            }}
          >
            <img src='/assets/shared/svg/forecast_bolt.svg' style={{ width: '15px' }} />
            &nbsp;&nbsp;Run Forecast Now
          </Button>
          <Button
            disabled={schedulingReport}
            onClick={this.scheduleReport}
            style={{
              color: getColorTheme('secondaryButtonText'),
              marginBottom: '20px',
              marginTop: '20px',
              marginLeft: '40px',
            }}
          >
            {schedulingReport && (
              <div>
                <CircularProgress size={12} />
                &nbsp;&nbsp;
              </div>
            )}
            <img src='/assets/shared/svg/forecast_email.svg' style={{ width: '20px' }} />
            &nbsp;&nbsp; Receive By Email
          </Button>
          {isSuperUser &&
            forecast !== undefined &&
            forecast.UniqueQuery !== undefined &&
            this.renderForecastDebugQuery(forecast)}
        </div>
      );
    }

    renderFirstPartySegments(isAutoUploadSegment: boolean) {
      const { classes } = this.props;

      const { writeAuthorization, saving, uploading, URL } = this.state;

      return (
        <div>
          <Paper
            classes={{
              root: classes.paper,
            }}
          >
            <Grid container>
              <Grid item xs={12} md={9}>
                <div className={classes.section}>
                  <TextField
                    label='URL'
                    name='URL'
                    fullWidth
                    multiline
                    value={URL || ''}
                    onChange={this.handleChange}
                    disabled={isAutoUploadSegment}
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={3}>
                <div className={classes.section}>
                  {/* Hide upload button for AudienceTypeFirstPartyAutoUpload */}
                  {!isAutoUploadSegment && (
                    // @ts-ignore
                    <ModelSecondaryButton
                      component='label'
                      startIcon={
                        <Icon style={{ fontSize: '1rem', marginLeft: '0.5rem' }}>backup</Icon>
                      }
                      disabled={uploading || saving || !writeAuthorization.isAuthorized}
                    >
                      Upload File&nbsp;
                      {uploading && <CircularProgress size={12} />}
                      <input
                        type='file'
                        style={{ display: 'none' }}
                        accept='.csv'
                        onChange={this.handleFileSelect}
                      />
                    </ModelSecondaryButton>
                  )}
                </div>
              </Grid>
            </Grid>
            {this.renderForecastingTool()}
          </Paper>
        </div>
      );
    }

    renderLiverampOTTHub() {
      const { classes } = this.props;

      const { LiverampOTTHubPrefix } = this.state;

      const params = LiverampOTTHubPrefix.split('_');

      return (
        <div>
          <div>
            <Paper classes={{ root: classes.paper }}>
              <H3>LiveRamp OTT Hub</H3>
              <div className={classes.section}>
                <TextField
                  label='Parameters'
                  name='Parameters'
                  style={{ width: '300px' }}
                  disabled
                  multiline
                  value={[
                    `Customer ID:   ${params[0] || ''}`,
                    `Customer Name: ${params[1] || ''}`,
                    `Audience ID:   ${params[3] || ''}`,
                    `Audience Name: ${params[2] || ''}`,
                  ].join('\n')}
                />
                {isExistingSegment(this.state) && this.renderForecastingTool()}
              </div>
            </Paper>
          </div>
        </div>
      );
    }

    renderLiverampDataStore() {
      const { classes } = this.props;

      return (
        <div>
          <div>
            <Paper classes={{ root: classes.paper }}>
              <H3>Audience segments</H3>
              <p>Explore &amp; pick audiences from data provider to build your segment</p>
              {this.renderLiveRamp()}
            </Paper>
          </div>
        </div>
      );
    }

    renderSegmentsDataStoreByPartner(audienceSegmentPartner: AudienceSegmentThirdPartyPartner) {
      const { classes } = this.props;

      return (
        <div>
          <div>
            <Paper classes={{ root: classes.paper }}>
              <H3>Audience segments</H3>
              <p>Explore &amp; pick audiences from data provider to build your segment</p>
              {this.renderSegmentsDMPTaxonomy(audienceSegmentPartner)}
            </Paper>
          </div>
        </div>
      );
    }

    toggleTransunionRenderMode = () => {
      this.setState({
        showTransunionTree: !this.state.showTransunionTree,
      });
    };

    renderTransunionTree = (transunionTree: ITransunionNode[]) => {
      const { classes } = this.props;
      let id = 0;

      const renderTransunionNode = (node: ITransunionNode) => {
        id += 1;
        if (node.children.length === 0) {
          return (
            <TreeItem nodeId={'' + id} label={node.value}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.getCheckboxStatus((node.data || {}).ID)}
                    name={(node.data || {}).ID}
                    onChange={() => {
                      this.handleSegmentIDToggle((node.data || {}).ID, [
                        ...(node.data?.Name || []),
                        node.data?.Description || '',
                      ]);
                    }}
                    color='primary'
                  />
                }
                label={`${(node.data || {}).ID} | ${(node.data || {}).Meta1} | ${
                  (node.data || {}).Meta2
                } | ${(node.data || {}).Description} | ${(node.data || {}).Price}`}
              />
            </TreeItem>
          );
        } else {
          return (
            <TreeItem nodeId={'' + id} label={node.value}>
              {node.children.map((child: ITransunionNode) => {
                return renderTransunionNode(child);
              })}
            </TreeItem>
          );
        }
      };

      return (
        <div>
          <div className={classes.section}>
            <TreeView
              className={classes.root}
              defaultCollapseIcon={<ExpandMoreIcon />}
              defaultExpandIcon={<ChevronRightIcon />}
            >
              {transunionTree.map((node: ITransunionNode) => {
                return renderTransunionNode(node);
              })}
            </TreeView>
          </div>
        </div>
      );
    };

    renderTransunionList(transunionData: ITransunionData[]) {
      const { classes } = this.props;

      return (
        <>
          <div className={classes.section}>
            {transunionData.map((data: ITransunionData) => {
              return (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.getCheckboxStatus(data.ID)}
                      name={data.ID}
                      onChange={() => {
                        this.handleSegmentIDToggle(data.ID, [...data.Name, data.Description]);
                      }}
                      color='primary'
                    />
                  }
                  label={`${data.ID} | ${data.Meta1} | ${data.Meta2} | ${data.Description} | ${data.Price}`}
                />
              );
            })}
          </div>
        </>
      );
    }

    renderTransunion = () => {
      const { transunionData, transunionTree } = this.state;

      return (
        <>
          <div>
            <Checkbox
              name='showTransunionTree'
              checked={this.state.showTransunionTree}
              onChange={this.toggleTransunionRenderMode}
            />
            Display Transunion Selection as Tree
          </div>
          <Divider
            style={{
              marginBottom: '24px',
              marginTop: '14px',
              height: '2px',
              maxWidth: '480px',
            }}
          />
          {this.state.showTransunionTree
            ? this.renderTransunionTree(transunionTree)
            : this.renderTransunionList(
                transunionData.filter((data: ITransunionData) => {
                  return (
                    this.props.segment.ThirdPartySegmentIDs.split(',').includes(data.ID) ||
                    this.state.ThirdPartySegmentIDs.split(',').includes(data.ID)
                  );
                }),
              )}

          {this.renderNewSegmentLogic()}

          {isExistingSegment(this.state) && this.renderForecastingTool()}
        </>
      );
    };

    renderTransunionSection = () => {
      const { classes } = this.props;
      return (
        <div>
          <div>
            <Paper classes={{ root: classes.paper }}>
              <H3>Audience segments</H3>
              <p>Explore &amp; pick audiences from data provider to build your segment</p>
              {this.renderTransunion()}
            </Paper>
          </div>
        </div>
      );
    };

    renderCadent() {
      const { classes } = this.props;

      const { CadentFilePath, CadentMeta } = this.state;

      // example: CadentFilePath: segments/20210724/146_brucetesting/
      let updateDate = '';
      const dateStr = CadentFilePath.split('/')[1];
      if (/^\d{8}$/.test(dateStr || '')) {
        updateDate =
          dateStr.substring(0, 4) + '-' + dateStr.substring(4, 6) + '-' + dateStr.substring(6);
      }

      // example: CadentMeta: 4info_PBL_D_4135|4INFO-4info_PBL_D_4139_name
      const cadentID = CadentMeta.split('|')[0];

      return (
        <div>
          <div>
            <Paper classes={{ root: classes.paper }}>
              <H3>Cadent Audience Segment</H3>
              <div className={classes.section}>
                <TextField
                  label='Parameters'
                  name='Parameters'
                  style={{ width: '300px' }}
                  disabled
                  multiline
                  value={[
                    `Update Date:   ${updateDate || ''}`,
                    `Cadent ID: ${cadentID || ''}`,
                  ].join('\n')}
                />
                {isExistingSegment(this.state) && this.renderForecastingTool()}
              </div>
            </Paper>
          </div>
        </div>
      );
    }

    getCheckboxStatus(segmentID: string | undefined): boolean {
      if (segmentID === undefined || segmentID === '' || this.state.ThirdPartySegmentIDs === '') {
        return false;
      }
      return this.state.ThirdPartySegmentIDs.indexOf(segmentID) > -1;
    }

    handleSegmentIDToggle(
      thirdPartySegmentID: string | undefined,
      thirdPartySegmentName: string[] | undefined = undefined,
    ) {
      if (thirdPartySegmentID === undefined || thirdPartySegmentID === '') {
        return;
      }
      if (this.state.ThirdPartySegmentIDs === '') {
        this.setState({
          ThirdPartySegmentIDs: thirdPartySegmentID,
        });
        this.trackEvent(
          'Audience Manager - Selection Tree',
          thirdPartySegmentID,
          thirdPartySegmentName,
          true,
        );
      } else if (this.state.ThirdPartySegmentIDs.indexOf(thirdPartySegmentID) === -1) {
        this.setState({
          ThirdPartySegmentIDs: this.state.ThirdPartySegmentIDs + ',' + thirdPartySegmentID,
        });
        this.trackEvent(
          'Audience Manager - Selection Tree',
          thirdPartySegmentID,
          thirdPartySegmentName,
          true,
        );
      } else {
        const thirdPartySegmentIDsToArray = this.state.ThirdPartySegmentIDs.split(',');
        const idx = thirdPartySegmentIDsToArray.indexOf(thirdPartySegmentID);
        if (idx > -1) {
          thirdPartySegmentIDsToArray.splice(idx, 1);
        }
        this.setState({
          ThirdPartySegmentIDs: thirdPartySegmentIDsToArray.join(','),
        });
        this.trackEvent(
          'Audience Manager - Selection Tree',
          thirdPartySegmentID,
          thirdPartySegmentName,
          false,
        );
      }
    }

    toggleLiveRampRenderMode = () => {
      this.setState({
        showLiveRampTree: !this.state.showLiveRampTree,
      });
    };

    renderLiveRamp() {
      if (this.state.loadingLiverampDataStore) {
        return (
          <>
            <CircularProgress size={12} />
            &nbsp;Loading...
          </>
        );
      }
      const sortedLiverampTree = sortLiveRampTree(this.state.parsedLiverampTree);
      const filteredLiveRampTree = searchLiveRampTree(
        sortedLiverampTree,
        this.state.searchTreeText.toLowerCase(),
      );

      return (
        <>
          <div>
            <Checkbox
              name='showLiveRampTree'
              checked={this.state.showLiveRampTree}
              onChange={this.toggleLiveRampRenderMode}
            />
            Display LiveRamp Selection as Tree
          </div>
          <Divider
            style={{
              marginBottom: '24px',
              marginTop: '14px',
              height: '2px',
              maxWidth: '480px',
            }}
          />
          {this.state.showLiveRampTree
            ? this.renderLiveRampTree(filteredLiveRampTree)
            : this.renderLiveRampList(
                this.state.parsedLiverampData.filter((data: ILiveRampData) => {
                  return (
                    this.props.segment.ThirdPartySegmentIDs.split(',').includes(
                      data.DataStoreSegmentID,
                    ) ||
                    this.state.ThirdPartySegmentIDs.split(',').includes(data.DataStoreSegmentID)
                  );
                }),
              )}

          {this.renderNewSegmentLogic()}

          {isExistingSegment(this.state) && this.renderForecastingTool()}
        </>
      );
    }

    renderSegmentsDMPTaxonomy(audienceSegmentPartner: AudienceSegmentThirdPartyPartner) {
      if (this.state.loadingCurrentDMPDataStore) {
        return (
          <>
            <CircularProgress size={12} />
            &nbsp;Loading...
          </>
        );
      }

      let dmpTaxonomyData = this.state.currentDMPDataStore;

      if (dmpTaxonomyData.length === 0) {
        return (
          <>
            <p>No data found, you must have taxonomy data within the last 90 days</p>
          </>
        );
      }

      if (this.state.searchTreeText !== '') {
        dmpTaxonomyData = filterDMPTaxonomyDataBySearchText(
          dmpTaxonomyData,
          this.state.searchTreeText,
        );
      }
      return (
        <>
          <div>
            <Checkbox
              name='showSelectedDMPSegments'
              checked={this.state.showSelectedDMPSegments}
              onChange={() => {
                this.setState({
                  showSelectedDMPSegments: !this.state.showSelectedDMPSegments,
                });
              }}
            />
            {`Display All Selected ${audienceSegmentPartner} Segments`}
          </div>
          <Divider
            style={{
              marginBottom: '24px',
              marginTop: '14px',
              height: '2px',
              maxWidth: '480px',
            }}
          />
          {this.state.showSelectedDMPSegments
            ? this.renderSegmentsDMPTaxonomyData(dmpTaxonomyData, audienceSegmentPartner, true)
            : this.renderSegmentsDMPTaxonomyData(dmpTaxonomyData, audienceSegmentPartner, false)}

          {this.renderNewSegmentLogic()}
          {isExistingSegment(this.state) && this.renderForecastingTool()}
        </>
      );
    }

    renderSegmentsDMPTaxonomyData(
      dmpSegments: ISegmentsDMPTaxonomy[],
      audienceSegmentPartner: AudienceSegmentThirdPartyPartner,
      showSelectedOnly: boolean,
    ) {
      const { classes } = this.props;

      return (
        <>
          <div className={classes.section}>
            <Grid>
              <TextField
                placeholder={`Search ${audienceSegmentPartner}`}
                variant='outlined'
                value={this.state.searchTreeText}
                onChange={this.handleSetSearchTreeText}
                size='small'
                style={{ width: '400px', marginBottom: '8px' }}
              />
            </Grid>

            <div className={classes.section}>
              {dmpSegments
                .map((data: ISegmentsDMPTaxonomy) => {
                  const isSelected = this.getCheckboxStatus(data.DMPSegmentID);
                  const formControlLabelComponent = (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isSelected}
                          name={data.DMPSegmentID}
                          onChange={() => {
                            this.handleSegmentIDToggle(data.DMPSegmentID, [
                              data.DataProviderName,
                              data.DataProviderID,
                              data.HeirarchicalSegmentName,
                            ]);
                          }}
                          color='primary'
                        />
                      }
                      label={
                        data.DMPSegmentID +
                        ' > ' +
                        data.DataProviderName +
                        ' > ' +
                        data.DataProviderID +
                        ' > ' +
                        data.HeirarchicalSegmentName
                      }
                    />
                  );

                  if (showSelectedOnly) {
                    if (isSelected) {
                      return formControlLabelComponent;
                    }
                    return null;
                  } else {
                    return formControlLabelComponent;
                  }
                })
                .filter((data) => data !== null)}
            </div>
          </div>
        </>
      );
    }

    renderLiveRampList(liverampData: ILiveRampData[]) {
      const { classes } = this.props;

      return (
        <>
          <div className={classes.section}>
            {liverampData.map((data: ILiveRampData) => {
              return (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.getCheckboxStatus(data.DataStoreSegmentID)}
                      name={data.DataStoreSegmentID}
                      onChange={() => {
                        this.handleSegmentIDToggle(data.DataStoreSegmentID, [
                          ...data.Name,
                          data.Description,
                        ]);
                      }}
                      color='primary'
                    />
                  }
                  label={
                    data.DataStoreSegmentID +
                    ' | ' +
                    data.Description +
                    ' | ' +
                    data.Provider +
                    ' | ' +
                    data.Price
                  }
                />
              );
            })}
          </div>
        </>
      );
    }

    renderLiveRampTree(liverampTree: ILiveRampNode[]) {
      const { classes } = this.props;
      const renderLiveRampNode = (node: ILiveRampNode) => {
        if (node.children.length === 0) {
          return (
            <div style={{ display: node.selected ? 'block' : 'none' }}>
              <TreeItem nodeId={node.id.toString()} label={node.value}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.getCheckboxStatus((node.data || {}).DataStoreSegmentID)}
                      name={(node.data || {}).DataStoreSegmentID}
                      onChange={() => {
                        this.handleSegmentIDToggle((node.data || {}).DataStoreSegmentID, [
                          ...(node.data?.Name || []),
                          node.data?.Description || '',
                        ]);
                      }}
                      color='primary'
                    />
                  }
                  label={
                    (node.data || {}).DataStoreSegmentID +
                    ' | ' +
                    (node.data || {}).Description +
                    ' | ' +
                    (node.data || {}).Provider +
                    ' | ' +
                    (node.data || {}).Price
                  }
                />
              </TreeItem>
            </div>
          );
        } else {
          return (
            <div style={{ display: node.selected ? 'block' : 'none' }}>
              <TreeItem nodeId={node.id.toString()} label={node.value}>
                {node.children.map((child: ILiveRampNode) => {
                  return renderLiveRampNode(child);
                })}
              </TreeItem>
            </div>
          );
        }
      };

      return (
        <div>
          <div className={classes.section}>
            <Grid>
              <TextField
                placeholder='Search Tree'
                variant='outlined'
                value={this.state.searchTreeText}
                onChange={this.handleSetSearchTreeText}
                size='small'
                style={{ width: '400px', marginBottom: '8px' }}
              />
            </Grid>
            <TreeView
              className={classes.root}
              defaultCollapseIcon={<ExpandMoreIcon />}
              defaultExpandIcon={<ChevronRightIcon />}
            >
              {liverampTree.map((node: ILiveRampNode) => {
                return renderLiveRampNode(node);
              })}
            </TreeView>
          </div>
        </div>
      );
    }

    renderCombineSegmentsLogic = () => {
      const { AudienceSegmentType, segmentList } = this.state;

      const SegmentType = [
        {
          label: 'Liveramp Data Store',
          value: AudienceSegmentTypeLiverampDataStore,
        },
      ];
      return (
        <Panels maxWidth vertical relative minWidthMain paddingBottom={spacing.medium}>
          <Panel paper horizontalPadding verticalPadding>
            <Rows>
              <Row noPadding>
                <Cols
                  extraSmallHorizontalPadding
                  verticalPadding
                  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
                >
                  <Col width={200}>
                    <Text title> Select Type </Text>
                  </Col>
                  <Col marginTop='-25px'>
                    <SingleSelect
                      label='Segment Type'
                      name='AudienceSegmentType'
                      onChange={this.handleChangeSegmentType}
                      value={AudienceSegmentType}
                      items={SegmentType}
                      style={{ width: '480px' }}
                    />
                  </Col>
                </Cols>
              </Row>
              <Row noPadding>
                <Cols
                  extraSmallHorizontalPadding
                  smallVerticalPadding
                  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
                >
                  <Col width={200}>
                    <Cols>
                      <Col>
                        <Text title> Select Segments </Text>
                      </Col>
                      <Col marginLeft={spacing.small} marginTop='1px'>
                        <Tooltip title='These segments will only be used to add audiences into the new segment. Once saved, we will not be storing information on the segments that were combined here, and future changes to those segments will not automatically be reflected here.'>
                          <InfoIcon
                            style={{
                              width: '1rem',
                              color: publicaColors.gray,
                            }}
                          />
                        </Tooltip>
                      </Col>
                    </Cols>
                  </Col>
                  <Col>
                    <MaterialSearchDropdownMulti
                      selectAll={true}
                      menuTitle='segments'
                      list={segmentList}
                      onChange={(segmentList: IMenuList) => this.setState({ segmentList })}
                      handleMenuAcceptClick={this.handleItemAcceptClick}
                      disabled={!AudienceSegmentType}
                      width='480px'
                    />
                  </Col>
                  {this.state.selectedSegmentIDs.length < 1 && this.state.AudienceSegmentType && (
                    <Col
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        color: publicaColors.gray,
                        backgroundColor: publicaColors.veryLightGray,
                        borderRadius: '5px',
                        marginLeft: spacing.medium,
                        marginTop: spacing.small,
                      }}
                      extraSmallPadding
                    >
                      <WarningIcon style={{ fontSize: '16px', marginRight: spacing.small }} />
                      <Typography style={{ fontSize: '12px' }}>
                        Select at least 1 segment to combine.
                      </Typography>
                    </Col>
                  )}
                </Cols>
              </Row>
            </Rows>
          </Panel>
        </Panels>
      );
    };

    renderToolbar() {
      const { user } = this.props;
      const { ID, Name, writeAuthorization } = this.state;
      return (
        <Cols
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: 'thin solid lightgray',
          }}
          smallVerticalPadding
          largeHorizontalPadding
        >
          <Cols style={{ flexDirection: 'row', alignItems: 'center' }}>
            <Col marginLeft='-5px'>
              <ModernTextField
                value={Name}
                onChange={this.handleChange}
                customStyle={{
                  fontSize: 15,
                  width: '450px',
                  minWidth: '300px',
                  height: '35px',
                }}
              />
            </Col>
            <Col width={200} smallPadding>
              {hasRoleSuperUser(user.user) && !!ID && (
                <div style={{ color: publicaColors.gray }}>ID * {ID}</div>
              )}
            </Col>
            <Col>
              {isExistingSegment(this.state) && !writeAuthorization.isAuthorized && (
                <ChipInactive label='Read-Only' />
              )}
            </Col>
          </Cols>
          <Cols style={{ flexDirection: 'row', alignItems: 'center' }}>
            <Col smallPadding>
              {this.state.AudienceSegmentType && (
                <ButtonView
                  onClick={() => this.saveSegment()}
                  text='Save'
                  active={this.state.saving}
                  disabled={this.state.uploading || this.state.saving}
                />
              )}
            </Col>
            <Col smallPadding>
              <ModelSecondaryButton onClick={this.gotoAudienceManagerSettings}>
                Close
              </ModelSecondaryButton>
            </Col>
            {isExistingSegment(this.state) && (
              <Col marginRight='5px'>
                <IconButton
                  aria-label='delete'
                  onClick={this.handleDeleteSegment}
                  disabled={!writeAuthorization.isAuthorized}
                >
                  <DeleteIcon />
                </IconButton>
              </Col>
            )}
          </Cols>
        </Cols>
      );
    }

    render() {
      const { classes, user, session, location, combineSegments } = this.props;
      const { pathname } = location;
      const {
        readAuthorization,
        writeAuthorization,
        snackbarError,
        snackbarMessage,
        AudienceSegmentType,
        IsFirstParty,
        Partner,
      } = this.state;
      const exist = isExistingSegment(this.state);

      if (exist && !readAuthorization.isAuthorized) {
        return <ModelMissingPermission missingPermissions={readAuthorization.missingPermissions} />;
      }

      if (!exist && !writeAuthorization.isAuthorized) {
        return (
          <ModelMissingPermission missingPermissions={writeAuthorization.missingPermissions} />
        );
      }

      const SegmentType = [
        {
          label: 'First Party Segments',
          value: AudienceSegmentTypeFirstParty,
        },
      ];

      if (
        session.publisher.LiverampEnabled === EBool.EBool_TRUE &&
        session.publisher.LiverampDataStore !== ''
      ) {
        SegmentType.push({
          label: 'Liveramp Data Store',
          value: AudienceSegmentTypeLiverampDataStore,
        });
      }
      if (session.publisher.TransunionEnabled === EBool.EBool_TRUE) {
        SegmentType.push({
          label: 'Transunion Segments',
          value: AudienceSegmentTypeTransunion,
        });
      }
      if (
        session.publisher.SamsungDMPEnabled === EBool.EBool_TRUE &&
        session.publisher.SamsungDMPDataStore !== ''
      ) {
        SegmentType.push({
          label: 'Samsung DMP Segments',
          value: AudienceSegmentTypeSamsungDMP,
        });
      }

      if (session.publisher.OnePlusXDMPEnabled === EBool.EBool_TRUE) {
        SegmentType.push({
          label: '1PlusX DMP Segments',
          value: AudienceSegmentTypeOnePlusXDMP,
        });
      }

      return (
        <Panels maxWidth vertical relative minWidthMain>
          <Panel
            largeHorizontalPadding
            verticalPadding
            style={{ borderBottom: `1px solid ${publicaColors.lightGray}` }}
          >
            <ModelTopBar
              title={routeName(pathname)}
              session={session}
              user={user}
              publisher={session.publisher}
              classes={classes}
              delegateElevate={true}
              currentPath={pathname}
              disableTitlePaddingLeft
            />
          </Panel>
          <Panel>{this.renderToolbar()}</Panel>
          <Panel scroll style={{ height: '100vh' }}>
            <Panels maxWidth vertical relative minWidthMain largePadding>
              {!isExistingSegment(this.state) &&
                IsFirstParty === AudienceSegmentIsFirstPartyUnknown && (
                  <Panel extraSmallHorizontalPadding marginBottom='5px'>
                    <Text style={{ fontSize: '1.1rem', fontWeight: 500 }}>Select Type</Text>
                    {combineSegments ? (
                      <Text style={{ fontSize: '0.9rem', color: publicaColors.gray }}>
                        Edit segment name, select type and audiences from existing segments to
                        combine.
                      </Text>
                    ) : (
                      <Text style={{ fontSize: '0.9rem', color: publicaColors.gray }}>
                        Edit segment name and select type below.
                      </Text>
                    )}
                  </Panel>
                )}
              {!isExistingSegment(this.state) && !combineSegments && (
                <Panel paper largeHorizontalPadding smallVerticalPadding marginBottom='24px'>
                  <SingleSelect
                    label='Segment Type'
                    name='AudienceSegmentType'
                    onChange={this.handleChangeSelect}
                    value={AudienceSegmentType}
                    items={SegmentType}
                    style={{ width: '600px' }}
                  />
                </Panel>
              )}
              {combineSegments && this.renderCombineSegmentsLogic()}
              {AudienceSegmentType === AudienceSegmentTypeFirstParty &&
                this.renderFirstPartySegments(false)}
              {AudienceSegmentType === AudienceSegmentTypeFirstPartyAutoUpload &&
                this.renderFirstPartySegments(true)}
              {Partner === AudienceSegmentThirdPartyPartnerLiveRamp &&
                AudienceSegmentType === AudienceSegmentTypeLiverampDataStore &&
                this.renderLiverampDataStore()}
              {Partner === AudienceSegmentThirdPartyPartnerLiveRamp &&
                AudienceSegmentType === AudienceSegmentTypeLiverampOTTHub &&
                this.renderLiverampOTTHub()}
              {Partner === AudienceSegmentPartnerSamsungDMP &&
                AudienceSegmentType === AudienceSegmentTypeSamsungDMP &&
                this.renderSegmentsDataStoreByPartner(AudienceSegmentPartnerSamsungDMP)}
              {Partner === AudienceSegmentThirdPartyPartnerCadent && this.renderCadent()}
              {Partner === AudienceSegmentThirdPartyPartnerTransUnion &&
                AudienceSegmentType === AudienceSegmentTypeTransunion &&
                this.renderTransunionSection()}
              {Partner === AudienceSegmentPartnerOnePlusXDMP &&
                AudienceSegmentType === AudienceSegmentTypeOnePlusXDMP &&
                this.renderSegmentsDataStoreByPartner(AudienceSegmentPartnerOnePlusXDMP)}
              <Snackbar
                open={true}
                anchorOrigin={{
                  horizontal: 'right',
                  vertical: 'bottom',
                }}
              >
                <ModelSnackBarProgressBarContainer uploadManager={this.uploadManager} />
              </Snackbar>
              <SnackbarView
                open={!!snackbarMessage}
                error={!!snackbarError}
                onClose={this.snackbarClose}
              >
                {snackbarMessage}
              </SnackbarView>
            </Panels>
          </Panel>
        </Panels>
      );
    }
  },
);
